import cn from 'classnames';
import React from 'react';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';
import withProfileUrl, { ProfileUrlData } from 'app/blocks/common/withProfileUrl';
import './profile-link.scss';
import './user-name.scss';

const ProfileLink = ({ error, text, url }: ProfileUrlData & { text: string }) => {
    return (
        <a
            className={cn('UserNameDropdown-item', {
                'UserNameDropdown-itemDisabled': !url,
            })}
            data-seleniumid="menu-profile-btn"
            href={url}
            rel="noreferrer"
            target="_blank"
        >
            {text}
            {!url && !error && (
                <SvgIcon.loading className="ProfileLink-Icon--loading" iconTitle="Profile url loading" />
            )}
            {!url && error && <SvgIcon.error className="ProfileLink-Icon" iconTitle="Cannot link account page" />}
        </a>
    );
};

export default withProfileUrl(ProfileLink);
export { ProfileLink };
